var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Input',{attrs:{"value":_vm.data,"readonly":_vm.readonly,"roles":_vm.roles},on:{"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }